
export const FontWeight = {
    no900: '900' as const,
    bold: 'bold' as const,
    normal: 'normal' as const,
}
